"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.yobi = exports.zebi = exports.exbi = exports.pibi = exports.tebi = exports.gibi = exports.mebi = exports.kibi = exports.bytes = void 0;
var numberMeasure_1 = require("../measure/numberMeasure");
var base_1 = require("./base");
exports.bytes = numberMeasure_1.Measure.of(8, base_1.bits, "B");
// HACKHACK: Explicitly type this so we can import PrefixFunction and avoid absolute paths in the generated typings.
exports.kibi = numberMeasure_1.Measure.prefix("Ki", 1 << 10);
exports.mebi = numberMeasure_1.Measure.prefix("Mi", 1 << 20);
exports.gibi = numberMeasure_1.Measure.prefix("Gi", 1 << 30);
exports.tebi = numberMeasure_1.Measure.prefix("Ti", 1 << 40);
exports.pibi = numberMeasure_1.Measure.prefix("Pi", 1 << 50);
exports.exbi = numberMeasure_1.Measure.prefix("Ei", 1 << 60);
exports.zebi = numberMeasure_1.Measure.prefix("Zi", 1 << 70);
exports.yobi = numberMeasure_1.Measure.prefix("Yi", 1 << 80);
//# sourceMappingURL=memory.js.map